import { queryIndustryList } from "@api/xxcrm/protect";
import localDb from "@util/localDb";

// 按模块的action, reducer整合体
const INDUSTRY_LIST = 'INDUSTRY_LIST';

export function getindustryList() {
  return dispatch => {
    return queryIndustryList().then(res => {
      if (res.statusCode === 200) {
        localDb.set(INDUSTRY_LIST, res.data);
        return dispatch({
          type: INDUSTRY_LIST,
          data: res.data,
        });
      }
    });
  };
}

// Reducer
export function industryList(state = {}, action) {
  switch (action.type) {
    case INDUSTRY_LIST:
      return action.data;
    default:
      return localDb.get(INDUSTRY_LIST);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/industry_list.js